import { render, staticRenderFns } from "./TaginputModern.vue?vue&type=template&id=c1c0015c&"
import script from "./TaginputModern.vue?vue&type=script&lang=js&"
export * from "./TaginputModern.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports